import {ProcessStageTitle} from '@hconnect/common/components'
import {useProcessStages} from '@hconnect/common/hooks/useProcessStages'
import {Stack} from '@mui/material'
import {RemoveFilterButton} from '@widgets/common-filters'
import React from 'react'

import {FilterDropDown} from './FilterDropDown'
import type {CommonFilterDropDownProps} from './FilterDropDown'
import {SelectAllButton} from './SelectAllButton'

export const ProcessStageFilterDropDown: React.FC<
  CommonFilterDropDownProps<string> & {plantId: string}
> = (props) => {
  const {removeFilter, isCollapsible, selectAll, plantId} = props
  const stages = useProcessStages(plantId).data
  const options = stages ? Array.from(stages.keys()) : []

  return (
    <FilterDropDown
      {...props}
      options={options}
      keyName="processStage"
      renderValue={(value: string[]) => {
        return value.map((val) => (stages ? stages.get(val) : '')).join(',')
      }}
      customTemplate={(key) => <ProcessStageTitle stages={stages} stage={key} />}
      customDropDownFooter={(keyName) =>
        isCollapsible ? null : (
          <Stack>
            <SelectAllButton
              keyName={keyName}
              selectAll={() => selectAll && selectAll(keyName, options)}
            />
            <RemoveFilterButton keyName={keyName} removeFilter={removeFilter} />
          </Stack>
        )
      }
      fullWidth={false}
    />
  )
}
